import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AccordionGeneral } from "components/accordion";
import { fraudlist } from "constants/fraudawareness";
import parse from "html-react-parser";
import { useEffect, useState } from "react";

function FraudAwareness() {
  const [fraudAwarenessData, setFraudAwarenessData] = useState();
  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/fraud-awarenesses?pLevel`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      const jsonResponse = response.data.data[0];
      setFraudAwarenessData(jsonResponse);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchAboutData();
  }, []);

  return (
    <section className="section about container">
      <div>
        <h1 style={{ color: "#000045", fontWeight: "700" }}>
          {fraudAwarenessData?.title}
        </h1>
        {fraudAwarenessData?.description &&
          parse(fraudAwarenessData?.description)}
        {/* <p style={{ color: "#000045" }}>
          {fraudAwarenessData?.description}
          <a
            href="https://www.bnm.gov.my/financial-consumer-alert-list"
            target="blank"
          >
            HERE
          </a>
        </p> */}
      </div>
      <div className="col-12 container">
        <AccordionGeneral
          list={fraudAwarenessData?.FraudAwareness}
          source="cms"
        />
      </div>
    </section>
  );
}

export default FraudAwareness;
